//Services
import { UtilitesService } from "./utilites.service";

//Models
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Usuario } from "app/usuarios/models/user.model";
import { Observable } from "rxjs";
import { UsuarioFilter } from "../base-model/usuario-filter.model";
import { AuthService } from "./auth.service";

@Injectable()
export class UsuarioService {
    private readonly urlPrefix = "usuarios";

    constructor(
        private _http: HttpClient,
        public utilitesService: UtilitesService,
        public authService: AuthService
    ) { }

    /**
     * Cadastra usuário e empresa
     * @param data
     * @returns {Observable<Object>}
     */
    public create(data: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + this.urlPrefix + "/create", data, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Consulta por ID
     * @param id
     * @returns {Observable<any>}
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + "/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista
     * @param params
     * @returns {Observable<any>}
     */
    getAll(params: UsuarioFilter): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";
        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista
     * @param params
     * @returns {Observable<any>}
     */
    getLista(params: UsuarioFilter): Observable<ApiPaginationResponseDataNonNullable<Usuario>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";
        return this._http.get<ApiPaginationResponseDataNonNullable<Usuario>>(
            this.utilitesService.urlPrefix + this.urlPrefix + "/lista" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista Todos os usuários
     * @param params
     * @returns {Observable<any>}
     */
    getAllUsuarios(params: UsuarioFilter): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";
        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + "/listaTodos" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista Operadores
     * @param params
     * @returns {Observable<any>}
     */
    getListaOperadores(params: UsuarioFilter): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";
        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + "/listaOperadores" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    search(params: UsuarioFilter): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";

        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + "/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Consulta Tipo de Usuario
     * @param {string} query
     * @returns {Observable<any>}
     */
    tipoUsuario(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + this.urlPrefix + "/tipo-usuario", {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Realiza Switch Role
     * @param data Object
     * @returns Observable<any>
     */
    switchRole(data: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + this.urlPrefix + "/switch-role", data, {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
